import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.85 18L12 13.15L7.15 18L6 16.85L10.85 12L6 7.15L7.15 6L12 10.85L16.85 6L18 7.15L13.15 12L18 16.85L16.85 18Z" fill={ fill || 'currentColor' } />
    </svg>
);
